import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Arrow from "components/effects/rack/Arrow.js";
import {getPath} from './getPath.js';

const DraggingEdge = ({dragging, scrollContainer, container}) => { 
    let [pos, setPos] = useState(undefined);

    useEffect(() => {
        if (!dragging) {
            return;
        }
        let {transformation, x, y} = dragging;
        let fromId = transformation.id;
        let fromEl = document.getElementById("transformation-" + fromId);
        if (fromEl ) {
            let fromRect = fromEl.getBoundingClientRect();
            let bounds = container.current.getBoundingClientRect();
            let scrollTop = scrollContainer.current.scrollTop;
            setPos({
                x1: fromRect.left, 
                y1: fromRect.top - bounds.top,
                x2: x - 3,
                y2: y - bounds.top -2 
            });
        }
    }, [dragging]);

    if (!dragging || !pos) { return [] };

    let {x1, y1,x2,y2} = pos;

    return (
         <Arrow
          className="markov-edge new-edge" 
          tension={window.tension}
          pointerLength= {6}
          pointerWidth={4}
           points={[x1,y1,0.75*x1 + 0.25*x2, 0.75*y1 + 0.25*y2, 0.25*x1 + 0.75*x2, 0.25*y1 + 0.75*y2,  x2,y2]}
          strokeWidth={2} />
    );
}

const mapStateToProps = (state, props) => {
  return {
      dragging: state.groups.transformationEdgeDragging
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DraggingEdge);
